import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import ChannelCard from "./ChannelCard";
import { fetchAPI } from "../utils/fetchAPI";
import { useParams } from "react-router-dom";
import Video from "./Video";

const ChannelDetail = () => {
  const [channelDetail, setChannelDetail] = useState(null);
  const [videos, setVideos] = useState(null);
  const { id } = useParams(); // Take the id from the page

  // Fetch channel Detail and channel related video
  useEffect(() => {
    const fetchChannelDetail = async (id) => {
      const data = await fetchAPI(`channels?part=snippet,statistics&id=${id}`);
      setChannelDetail(data);
    };

    const fetchChannelVideo = async (id) => {
      const data = await fetchAPI(`search?part=snippet,id&channelId=${id}`)

      setVideos(data);
      console.log(data);
    };

    fetchChannelDetail(id);
    fetchChannelVideo(id);
  }, [id]);

  // Destrucutre information
  const data = channelDetail?.items[0];

  return (
    <Box minHeight="95vh">
      <Box>
        <div
          style={{
            height: "300px",
            background: "#12c2e9" /* fallback for old browsers */,
            background:
              "-webkit-linear-gradient(to right, #f64f59, #c471ed, #12c2e9)" /* Chrome 10-25, Safari 5.1-6 */,
            background:
              "linear-gradient(to right, #f64f59, #c471ed, #12c2e9)" /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */,
          }}
        />
      </Box>
      <Box>
        <ChannelCard channelDetail={data} marginTop="-93px" />
      </Box>
      <Box sx={{mt: 4, display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3}}>
          <Video videos={videos} direction="row" />
      </Box>
    </Box>
  );
};

export default ChannelDetail;
